const addLazyLoadingToImages = htmlString => {
  return htmlString.replace(/<img /g, '<img loading="lazy" ');
};

export default addLazyLoadingToImages;
